var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-checker',[_c('booking-select')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }